var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 9.00016V2.50016C9.16667 1.92553 9.39494 1.37443 9.80127 0.968098C10.2076 0.561769 10.7587 0.333496 11.3333 0.333496H37.3333C37.908 0.333496 38.4591 0.561769 38.8654 0.968098C39.2717 1.37443 39.5 1.92553 39.5 2.50016V32.8335C39.5 33.4081 39.2717 33.9592 38.8654 34.3656C38.4591 34.7719 37.908 35.0002 37.3333 35.0002H30.8333V41.5002C30.8333 42.6962 29.8583 43.6668 28.6515 43.6668H2.68183C2.39611 43.6685 2.11286 43.6138 1.84837 43.5057C1.58387 43.3976 1.34334 43.2383 1.14059 43.037C0.937848 42.8356 0.776885 42.5962 0.666951 42.3325C0.557017 42.0688 0.50028 41.7859 0.5 41.5002L0.5065 11.1668C0.5065 9.97083 1.4815 9.00016 2.68617 9.00016H9.16667ZM4.83767 13.3335L4.83333 39.3335H26.5V13.3335H4.83767ZM13.5 9.00016H30.8333V30.6668H35.1667V4.66683H13.5V9.00016ZM9.16667 19.8335H22.1667V24.1668H9.16667V19.8335ZM9.16667 28.5002H22.1667V32.8335H9.16667V28.5002Z",
    fill: "#19C1D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.14f1e0c9a3cdb529741b713d881de289.svg";
export { ForwardRef as ReactComponent };